import { Stack } from '@mui/material';

import { RecordingFeedbackBonusBanner } from '@/features/recordingFeedbackBonus';

import { IS_WHITE_LABEL } from '@/shared/environments';
import { inIframe } from '@/shared/lib/browser';
import { DesktopNavigation } from '@/shared/ui/DesktopNavigation';
import { Logo } from '@/shared/ui/Logo';
import { SidebarButton } from '@/shared/ui/SidebarButton';

import { RecordingProfile } from './RecordingProfile';
import { useRecordingSidebarNavigation } from './useRecordingSidebarNavigation';

type Props = {
  isAuthenticated?: boolean;
  isOpen?: boolean;
  locked?: boolean;
  handleCloseSidebar?: () => void;
  handleLocked?: () => void;
};

export const RecordingSidebarContent = ({
  isAuthenticated = true,
  isOpen = false,
  locked,
  handleCloseSidebar,
  handleLocked,
}: Props) => {
  const { bottomNavigation, isAccountActive, mainNavigation } = useRecordingSidebarNavigation({
    onAction: handleCloseSidebar,
  });
  const opened = isOpen || locked;
  const isTiktok = inIframe();

  return (
    <DesktopNavigation
      logoContainer={
        <Logo
          isCompact={!opened}
          isWhiteLabel={IS_WHITE_LABEL}
          target={isTiktok ? undefined : '_blank'}
          to={isTiktok ? '/' : 'https://www.rask.ai/'}
        >
          <SidebarButton locked={locked} onClick={handleLocked} />
        </Logo>
      }
      bottomNavigation={bottomNavigation}
      isOpen={opened}
      mainNavigation={mainNavigation}
      profileContainer={<RecordingProfile active={isAccountActive} isAuthenticated={isAuthenticated} />}
    >
      {opened && isAuthenticated && (
        <Stack margin="0 12px">
          <RecordingFeedbackBonusBanner />
        </Stack>
      )}
    </DesktopNavigation>
  );
};
